<template>
  <div class="p_box" id="box">
    <div id="head">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
        <el-breadcrumb-item>已做作业</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="mine_header p_m_t_30" id="tab">
      <div class=" header_left p_flex p_f_a ">
        <div class="p_flex p_f_a small_hand" v-for="(item, index) in headerList" :key="index" @click="goHeader(index)">
          <div :class="[headerIndex == index ? 'tababr_com' : '']">{{ item.name }}</div>
          <div v-show="headerIndex == index" class="header_heng"></div>
        </div>
      </div>
    </div>
    <div class="mine_list overflow small_hand" :style="{ height: height + 'px' }">
		<already-list :i='headerIndex' :data="data"></already-list>
		<el-pagination v-if="data.count >= 10" style="float: right;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="postData.page" :page-sizes="[5,10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" :page-size="10" layout="total,sizes, prev, pager, next" :total="data.count"></el-pagination>
    </div>

  </div>
</template>

<script>
  import AlreadyList from './commponents/alreadyList.vue';
  export default {
    name: 'Already',
    components: { AlreadyList },
    data() {
      return {
        headerIndex: 0,
        headerList: [{ name: '未批改' }, { name: '已批改' } ],
        show: false,
        height: 0,
        postData: {
          // page: 1,
          // limit: 10,
          corrects: 2,
        },
        data: { count:0, list:[] },
      };
    },
    mounted() {
      this.indexInfo();
    },
    watch: {
      '$route.path': {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal == '/Already') {
            var height = localStorage.getItem('height');
            if (height == '') {} else {
              this.height = height;
            }
          }
        }
      }
    },
    created(){
      this.getList()
    },
    beforeRouteLeave(to, form, next) {
      localStorage.removeItem('height');
      next();
    },
    methods: {

      getList(){
        this.$request.ajax(this).post('/api_student/job_publish_complete_job',this.postData).then(res=>{
			this.data = res.data
        })
      },

      indexInfo() {
        var box = document.getElementById('box').offsetHeight;
        var head = document.getElementById('head').offsetHeight;
        var tab = document.getElementById('tab');
        var tabHeight = tab.offsetHeight;
        var tabTop = tab.offsetTop;
        var height = box - head - tabHeight - 30;
        var heights = localStorage.getItem('height');
        if (heights == null) {
          localStorage.setItem('height', height);
        } else {}
        this.height = height;
      },
      // 头部切换
      goHeader(i) {
        // console.log(i)
        this.headerIndex = i;
        this.postData.corrects = i == 0 ? 2 : 1
        this.postData.page = 1
        this.getList()
      },

	  handleCurrentChange(e){ this.postData.page = e; this.getList() },

	  handleSizeChange(e){ this.postData.limit = e; this.getList() },
    }
  };
</script>
<style lang="scss" scoped>
  .mine_header {
    background-color: #fafafa;
    height: 60px;
  }

  .header_left>div {
    height: 100%;
    position: relative;
    margin-left: 260px;
  }

  .header_left>div:nth-child(2) {
    margin-left: 50px;
  }

  .header_left {
    height: 100%;
  }

  .header_heng {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 2px;
    background-color: #000000;
  }

  .tababr_com {
    font-weight: bold;
  }

  .heaer_btn {
    margin-left: 440px;
  }

  .mine_list {
    padding: 0 220px;
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/homes/already/index.vue